import { ActionTypes } from '../constants/constants'
import AppDispatcher from '../dispatcher/appDispatcher'
import { Contract, FuturesDatum, FuturesTile } from '../types'
import Store from './store'

function getRows(tiles: Record<string, FuturesTile>) {
  return Object.values(tiles)
    .map(function (tile) {
      return {
        label: tile.label,
        value: tile.change,
      }
    })
    .sort(function (a, b) {
      return b.value - a.value
    })
}

var _timeframe = 'i5'
var _rows: ReturnType<typeof getRows> = []
class RowsStore extends Store {
  getTimeframe() {
    return _timeframe
  }

  getRows() {
    return _rows
  }
}
var rowsStore = new RowsStore()

// @ts-ignore
rowsStore.dispatchToken = AppDispatcher.register(function (payload) {
  var action = payload.action

  switch (action.type) {
    case ActionTypes.INIT:
      var _tiles: Record<string, FuturesTile> = {}
      action.rows.forEach((group: FuturesDatum) => {
        group.contracts.forEach((contract: Contract) => {
          _tiles[contract.ticker] = contract
        })
      })

      _rows = getRows(_tiles)
      if (action.timeframe) {
        _timeframe = action.timeframe
      }
      rowsStore.emitChange()
      break

    case ActionTypes.CHANGE_TIMEFRAME_STARTED:
      _timeframe = action.period
      rowsStore.emitChange()
      break

    case ActionTypes.UPDATE_DATA:
      _rows = getRows(action.tiles)
      rowsStore.emitChange()
      break
  }
})

export default rowsStore
